import {
  subscribeToMessages,
  unsubscribeToMessages,
} from './api/simulateMessages';
import {
  getSimulateElements,
  clearSimulateElements,
} from './ui/simulateElements';
import {
  SimulateLaunchOptions,
  SimulateLaunchOptionsSchema,
} from '../../shares/model/simulate';
import { prepareSelectionsPayload } from './api/prepareSelections';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import { renderSimulateIframe } from './ui/renderIframe';
import eventEmitters from '../../shares/lib/eventEmitters';
import eventType from '../../shares/enums/eventType';
import { validate } from 'superstruct';

let isSimulateLaunched = false;

export async function simulateLaunch(options: SimulateLaunchOptions) {
  const swipeSDKConfig = getSDKConfig();

  if (!swipeSDKConfig.enableSimulate || !swipeSDKConfig.simulate) {
    return;
  }

  const [error] = validate(options, SimulateLaunchOptionsSchema);
  if (error) {
    console.error('Invalid simulate launch options', error);
    throw new Error('Invalid simulate launch options');
  }
  const iframeUrl = new URL(swipeSDKConfig.simulate.iframeSourceUrl ?? '');
  iframeUrl.searchParams.set(
    'tenant_id',
    swipeSDKConfig.simulate.tenantId
      ? swipeSDKConfig.simulate.tenantId
      : swipeSDKConfig.tenantId,
  );

  const { main, showLoader, showError, hideLoader } = getSimulateElements();

  try {
    showLoader();

    const iframe = await renderSimulateIframe(main, iframeUrl.toString());
    const iframeContent = iframe.contentWindow;

    await subscribeToMessages();

    const payload = await prepareSelectionsPayload(options);

    iframeContent?.postMessage(JSON.stringify(payload), iframeUrl.toString());

    eventEmitters(eventType.SIMULATE_READY, 'Simulate', {
      payload: payload,
      eventType: eventType.SIMULATE_READY,
    });

    hideLoader();
  } catch (e) {
    showError();
    throw e;
  } finally {
    isSimulateLaunched = true;
  }
}

export async function simulateRemove() {
  if (isSimulateLaunched) {
    await unsubscribeToMessages();
    clearSimulateElements();
    isSimulateLaunched = false;
    eventEmitters(eventType.SIMULATE_CLOSED, 'Simulate');
  }
}
